import { render, staticRenderFns } from "./newpromotion.vue?vue&type=template&id=80d5c27a&scoped=true"
import script from "./newpromotion.vue?vue&type=script&lang=js"
export * from "./newpromotion.vue?vue&type=script&lang=js"
import style0 from "./newpromotion.vue?vue&type=style&index=0&id=80d5c27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d5c27a",
  null
  
)

export default component.exports